/**
 * Check if the DOM has fully loaded and run a function
 * @param {function} callback
 */
 const ready = (callback) => {
   if(document.readyState != 'loading') {
      callback();
   } else {
      document.addEventListener('DOMContentLoaded', callback);
   }
}

ready(() => {
   /**
    * Project Listing Tabs
   */
   const postCatFilterSelect = document.getElementById('post-cat-filter');
   const postsOutput = document.getElementById('posts-output');

   function changeCategoryParam(value) {
      const queryParams = new URLSearchParams(window.location.search);
      queryParams.set("category", value);
      return history.replaceState(null, null, "?"+queryParams.toString());
   }

   postCatFilterSelect.addEventListener('change', e => {
      const select = e.target;
      const category = select.value;

      const categorySlug = select.options[select.selectedIndex].getAttribute('data-slug');
      changeCategoryParam(categorySlug);
      
      fetch(wp_ajax.ajax_url, {
         method: 'POST',
         body: new URLSearchParams({
            action: 'fetch_posts_by_cat',
            category
         }),
      })
      .then(response => response.text())
      .then(result => {
         postsOutput.innerHTML = result;
      })
   });

   // projectFilterAnchor.forEach(item => {
   //    item.addEventListener('click', () => {
   //       removeAllActiveAnchors();
   //       makeAnchorActive(item);

   //       const category = item.getAttribute('data-category');
   //       fetch(wp_ajax.ajax_url, {
   //          method: 'POST',
   //          body: new URLSearchParams({
   //             action: 'fetch_projects_by_cat',
   //             category
   //          }),
   //       })
   //       .then(response => response.text())
   //       .then(result => {
   //          projectOutput.innerHTML = result;
   //       })
   //    })
   // });
});